import { axios } from '@Root/API'

export const create = (qualificationAwardId, payload) => {
	return axios.post(`qualification-awarded/${qualificationAwardId}/accreditation`, payload)
}
